import React, { createContext, useContext, useState } from "react";

export type AppError = {
  code?: number | string;
  message?: string;
  description?: string;
  showRefresh?: boolean;
};

type ErrorContextType = {
  error: AppError | null;
  showError: (err: AppError) => void;
  clearError: () => void;
};

const ErrorContext = createContext<ErrorContextType | null>(null);

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [error, setError] = useState<AppError | null>(null);

  const showError = (err: AppError) => setError(err);
  const clearError = () => setError(null);

  return (
    <ErrorContext.Provider value={{ error, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useError must be used within ErrorProvider");
  }
  return context;
};